<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Depósito de documentos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Deposito de documentos</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <form autocomplete="off" [formGroup]="formHeader">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col " style="max-width: 200px;">
          <!-- Material checked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaFechaReg" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_FECHA_REGISTRO" />
            <label class="form-check-label" for="rbVistaFechaReg">Fecha Ingr.</label>
          </div>
          <!-- Material unchecked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaFechaVec" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_FECHA_VENCIMIENTO" />
            <label class="form-check-label" for="rbVistaFechaVec">Fecha Venc.</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <div style="margin-bottom: 30px;">
              <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
                formControlName="fechaDesde">
              </mdb-date-picker>
              <div
                *ngIf="formHeader.get('fechaDesde').invalid && (formHeader.get('fechaDesde').dirty || formHeader.get('fechaDesde').touched)">
                <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">
                  Ingrese fecha desde
                </mdb-error>
              </div>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <div style="margin-bottom: 30px;">
              <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
                formControlName="fechaHasta">
                <div *ngIf="
                                  formHeader.get('fechaHasta').invalid &&
                                  (formHeader.get('fechaHasta').dirty ||
                                  formHeader.get('fechaHasta').touched)
                                  ">
                  <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">
                    Ingrese fecha hasta
                  </mdb-error>
                </div>
              </mdb-date-picker>
            </div>

          </div>
        </div>
        <div class="col-sm-2">
          <div class="md-form">
            <mdb-select ngDefaultControl label="Banco" id="comunafiltro" #Bancofiltro multple [options]="optionsBanco"
              [multiple]="true" placeholder="Banco" [filterEnabled]="true" formControlName="bancos">
            </mdb-select>
          </div>
        </div>
        <div style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="" #rutcliente
              formControlName="rutCliente" formatRut />
            <label for="rutcliente">RUT</label>
            <div *ngIf="
                        formHeader.get('rutCliente').invalid &&
                        (formHeader.get('rutCliente').dirty ||
                        formHeader.get('rutCliente').touched)
                    ">
              <mdb-error *ngIf="formHeader.get('rutCliente').hasError('required')">
                Ingrese rut cliente
              </mdb-error>
            </div>
          </div>
        </div>
        <div style="max-width: 80px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarClientes()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>

        </div>
        <div class="col" style="width: 350px; align-self: center; margin: 0 auto;">
          <span class="text-info" style="display: contents; font-size: 12px; ">{{ clienteSeleccionado?.razon_social }}</span>
        </div>
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <mdb-select label="Estado" [options]="optionsTipoCheque" [multiple]="true" placeholder="Estado"
              [filterEnabled]="true" formControlName="tiposCheque">
            </mdb-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="md-form" style="padding: 3px; margin-left: 20px;">
          <input value="" type="text" id="nroCheque" class="form-control" placeholder="XXXXXXXXXX" #nroCheque
            formControlName="nroDoc" onlyNumbers style="width: 200px; font-size: 14px;" />
          <label for="nroCheque">Nro. de Cheque</label>
        </div>
        <div class="md-form" style="padding: 3px; margin-left: 10px;">
          <input value="" type="text" id="filtroMonto" class="form-control" placeholder="XXXXXXXXXX" #nroCheque
            formControlName="filtroMonto" onlyNumbers style="width: 200px; font-size: 14px;" />
          <label for="filtroMonto">Buscar por Monto</label>
        </div>
      </div>
    </div>
  </form>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div class="resultados pl-2"></div>
    <div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarData()">Limpiar</button>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar()"><mdb-icon fas
          icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">

    <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

    <div class="table-responsive" *ngIf="listaMovimientos">

      <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
      </app-no-data-alert>

      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos?.length > 0">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">
              <mdb-checkbox (change)="checkAllChange($event)"></mdb-checkbox>
            </th>
            <th scope="col">Nro. Doc.</th>
            <th scope="col">Fec. Ingreso</th>
            <th scope="col">Fec. Vcto.</th>
            <th scope="col">Banco</th>
            <th scope="col">RUT</th>
            <th scope="col">Cliente</th>
            <th scope="col">Origen</th>
            <th scope="col" class="text-center">Estado</th>
            <th scope="col" class="text-right">Monto</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mov of listaMovimientos">
            <td>
              <mdb-checkbox [checked]="mov.additionalInfo.checked" (change)='checkDetalle(mov.additionalInfo)'
                *ngIf="mov.estado_codigo === 6  || mov.estado_codigo === 4"></mdb-checkbox>
            </td>
            <td>{{mov.numero_doc}}</td>
            <td>{{mov.fecha_pago | fecha}}</td>
            <td>{{mov.fecha_vencimiento | fecha}}</td>
            <td>{{mov.banco_nombre}}</td>
            <td>{{mov.additionalInfo.rutClienteFormato | rut}}</td>
            <td>{{mov.cliente_proveedor_nombre}}</td>
            <td>{{mov.origen}}</td>
            <td class="text-center">
              <mdb-badge pill="true" info="true" *ngIf="mov.estado_codigo === 1">{{mov.estado_nombre}}
              </mdb-badge><!-- por depositar |  azul-->
              <mdb-badge pill="true" success="true" *ngIf="mov.estado_codigo === 2">{{mov.estado_nombre}}
              </mdb-badge><!-- depositado | verde -->
              <mdb-badge pill="true" danger="true" *ngIf="mov.estado_codigo === 3">{{mov.estado_nombre}}
              </mdb-badge><!-- protestado | rojo -->
              <mdb-badge pill="true" primary="true"
                *ngIf="mov.estado_codigo === 4 || mov.estado_codigo === 5">{{mov.estado_nombre}}
              </mdb-badge><!-- ingresado o Redeposito | morado -->
              <mdb-badge pill="true" warning="true" *ngIf="mov.estado_codigo === 6">{{mov.estado_nombre}}
              </mdb-badge><!-- vencido | amarillo -->

              <!-- <mdb-badge pill="true" warning="true" *ngIf="mov.estado_codigo === ">POR DEPOSITAR
                            </mdb-badge>
                            <mdb-badge pill="true" danger="true" *ngIf="mov.estado_codigo === ">VENCIDO</mdb-badge> -->
            </td>
            <td class="text-right">$ {{mov.monto | numerico}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
    <div class="row" *ngIf="listaMovimientosAll?.length > 0">
      <div class="col" style="max-width: 200px;">
        <Strong class="title">Nro. Documentos : </Strong>
        <span class="value" style="color: red;">{{docSeleccionado}}</span>
      </div>
      <div class="col" style="max-width: 200px;">
        <Strong class="title ">Total Selec. : </Strong>
        <span *ngIf="montoToltalSeleccion !== null" class="value" style="color: red;">$ {{montoToltalSeleccion |
          numerico}}</span>
      </div>
      <div class="card-body d-sm-flex p-1 justify-content-end">
        <div class="col" style="max-width: 200px; text-align: right;">
          <Strong class="title ">Total. : </Strong>
          <span *ngIf="montoToltal !== null" class="value" style="color: red;">$ {{montoToltal |
            numerico}}</span>
        </div>
      </div>
    </div>

  </div>
</div>

<div *ngIf="listaMovimientos && listaMovimientos.length > 0">
  <div class="card">
    <div class="card-body d-sm-flex p-1 justify-content-end">
      <button mdbBtn type="button" size="sm" class="btn btn-sm" color="success" mdbWavesEffect
        (click)="downloadExcelPdf('XLS')">
        Excel
      </button>
      <button mdbBtn type="button" size="sm" class="btn btn-sm" color="success" mdbWavesEffect
        (click)="depositarDocumentos()">
        Depositar documentos
      </button>
    </div>

  </div>
</div>

<!-- MODAL destinoDeposito -->
<app-modal-destino-deposito (onSuccess)="buscar()"></app-modal-destino-deposito>
<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT_BLO_DESB" showInfoClienteInactivoBloqueado="true"
  (onSelectSingle)="onClienteSeleccionado($event)" (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>
